/**
 * Truncates equipment name if it's too long for notification messages
 * @param name - The equipment name to truncate
 * @param maxLength - Maximum length before truncation (default: 30)
 * @returns Truncated name with ellipsis if needed
 */
export const truncateEquipmentName = (name: string, maxLength: number = 30): string => {
	if (!name || name.length <= maxLength) {
		return name;
	}

	// Truncate and add ellipsis
	return `${name.substring(0, maxLength)}...`;
};
